import { render } from "./Newsroom.vue?vue&type=template&id=0fd1d310&scoped=true"
import script from "./Newsroom.vue?vue&type=script&lang=js"
export * from "./Newsroom.vue?vue&type=script&lang=js"

import "./Newsroom.vue?vue&type=style&index=0&id=0fd1d310&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd1d310"]])

export default __exports__